import PropTypes from "prop-types";

export const _Filter = {
  categories: PropTypes.array,
  selectedCategory: PropTypes.string,
  setSelectedCategory: PropTypes.func,
};

export const FilterPropTypes = _Filter;
